import Swal from "sweetalert2";
import SendFormData from "./SendFormData";

export default () => {
  const subscribeButton = document.getElementsByClassName(
    "share__subscribe"
  )[0];
  subscribeButton.addEventListener("click", e => {
    e.preventDefault();

    Swal.fire({
      title: "Masukan email untuk Subscribe!",
      input: "email",
      confirmButtonColor: "#559fd6",
      confirmButtonText: "Subscribe",
      showLoaderOnConfirm: true,
      allowOutsideClick: () => !Swal.isLoading(),
      preConfirm: email => {
        new SendFormData({
          url: "/api/subscriptions",
          data: {
            subscription: {
              email
            }
          },
          successTitle: "Terima kasih telah Subscribe!",
          successMessage: "Nantikan informasi terbaru dari Bali Citra Medina"
        });
      }
    });
  });
};
